export const PSERVED_ROOM_PREFIX = '<sip:ROOMS-'
export const GUEST_PREFIX = '<sip:GUEST-'
export const NOTIFICATION_CONTACT_URI = '<sip:notification@system>'
export const CALL_CONTACT_URI = '<sip:calls@system>'
export const PSTNGUEST = 'PSTNGUEST'
export const GUEST = 'GUEST'

export const isSystemContactPServed = (pServed: string | undefined | null): boolean => {
  return pServed === NOTIFICATION_CONTACT_URI || pServed === CALL_CONTACT_URI
}
